module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow2.blue-132a429b26b2f8672103a2713b5e9697.png";